import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import { AgGridReact } from "ag-grid-react";
import { PaginationWrapper } from "components/atoms/mTablePagination/PaginationWrapper.tsx";
import { ResponsiveButton } from "components/atoms/responsiveButton";
import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";

import { contactsPageSize } from "../../../api/contactsPageSize";
import { statesDescriptor } from "../../../api/statesDescriptor";
import avatarSvg from "../../../assets/image/icons/svg/user.svg";
import selectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox2.svg";
import partiallySelectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox3.svg";
import notSelectedCheckboxIcon from "../../../assets/image/icons/tables/checkbox.svg";
import iconExcludeDisabled from "../../../assets/image/icons/tables/exclude-disabled.svg";
import iconExclude from "../../../assets/image/icons/tables/exclude.svg";
import inIconGray from "../../../assets/image/icons/tables/linkedin-icon-gray.svg";
import iconRemoveDisabled from "../../../assets/image/icons/tables/remove-disabled.svg";
import iconRemove from "../../../assets/image/icons/tables/remove.svg";
import { CONSTS } from "../../../config/objectConst";
import ButtonAddToCampaigns from "../../atoms/buttonAddToCampaigns";
import ButtonCreateCampaigns from "../../atoms/buttonCreateCampaigns";
import ConfirmationDialogContacts from "../../atoms/ConfirmationDialogContacts";
import ConfirmationDialogExclude from "../../atoms/ConfirmationDialogExclude";
import CustomCellRenderer from "../../atoms/customCellRenderer";
import CustomCheckbox from "../../atoms/customCheckbox";
import ExportToCSVButton from "../../atoms/ExportToCSVButton";
import HeaderCheckbox from "../../atoms/headerCheckbox";
import TableSettingsModal from "../../atoms/tableSettingsModal";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import "./style.scss";
import TooltipCustom from "../../atoms/tooltipCustom";
import CustomTooltipWrapper from "../../atoms/tooltipCustomWrapper";
import ModalWindow from "../ModalWindow";
import BtnGroupContainer from "./btn-group";
import {
  areDisabledSelectionActions,
  clearCheckboxes,
  deleteContacts,
  deleteHandler,
  dropDownController,
  dropDownControllerContact,
  exportContacts,
  exportContactsForCampaign,
  exportRecentActivities,
  getColumnProperty,
  getContactsBySort,
  getInitialWidth,
  getInitialWidthOrFlex,
  getInitialWidthOrFlexSmall,
  getNewPage,
  getStylePagination,
  handleChangePage,
  handleClick,
  handlerCompleteExecutions,
  heightGenerator,
  onClearAllClick,
  onClickExclude,
  onColumnResized,
  onGridReady,
  onSelectAllClick,
  onSelectAllPageClick,
  previewContacts,
  removeContactsFromCampaign,
  removeExecutionsFromCampaign,
  saveState,
  transformContactsData,
} from "./functions";
import InformationBlock from "./informationBlock";
import SortIcon from "./sortIcons";
import { appSelectors } from "../../../redux/reducers/app";
import { linkedInProfileOpener } from "api/linkedInProfileOpener";

const SHOW_ITEMS = [10, 25, 50, 100].map((amount) => ({
  label: `Show ${amount} items`,
  value: amount,
}));

class TableUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          cellRendererFramework: CustomCheckbox,
          cellRendererParams: {
            handleClick: handleClick.bind(this),
          },
          field: "select",
          headerComponentFramework: HeaderCheckbox,
          headerComponentParams: {
            handleChange: onSelectAllPageClick.bind(this),
          },
          headerName: "",
          hide: false,
          initialWidth: 65,
          suppressMovable: true,
        },
        {
          cellRendererFramework: CustomCellRenderer,
          field: "contact",
          headerName: "CONTACT",
          hide: getColumnProperty.call(
            this,
            "contact",
            false,
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
          ...getInitialWidthOrFlex.call(
            this,
            "contact",
            this.props.type === "single"
          ),
          headerComponentFramework: () =>
            this.createSortData("Contact", "full_name", "contact"),
        },

        {
          cellRendererFramework: (params) => (
            <CustomTooltipWrapper {...params} field="headline" />
          ),
          field: "headline",
          headerName: "HEADLINE",
          hide: getColumnProperty.call(
            this,
            "headline",
            false,
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
          ...getInitialWidthOrFlex.call(
            this,
            "headline",
            this.props.type === "single"
          ),

          headerComponentFramework: () =>
            this.createSortData("Headline", "occupation", "headline"),
        },
        {
          field: "location",
          headerName: "LOCATION",
          hide: getColumnProperty.call(
            this,
            "location",
            false,
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
          ...getInitialWidthOrFlexSmall.call(
            this,
            "location",
            this.props.type === "single"
          ),
          headerComponentFramework: () =>
            this.createSortData("Location", "location", "location"),
        },
        {
          field: "status",
          headerName: "STATUS",
          hide:
            this.props.type !== "single"
              ? true
              : getColumnProperty.call(
                  this,
                  "status",
                  this.props.type !== "single",
                  this.props.type === "single"
                ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
          ...getInitialWidthOrFlexSmall.call(
            this,
            "status",
            this.props.type === "single"
          ),
          cellRenderer: "CustomCellStatusRerender",
          headerComponentFramework: () => this.createData("Status"),
        },
        {
          field: "lastAction",
          headerName: "LAST ACTION",
          hide: getColumnProperty.call(
            this,
            "lastAction",
            false,
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
          ...getInitialWidthOrFlexSmall.call(
            this,
            "lastAction",
            this.props.type === "single"
          ),
          headerComponentFramework: () =>
            this.createSortData("Last Action", "contacted", "contacted"),
        },
        {
          field: "imported",
          headerName: "IMPORTED",
          hide:
            this.props.type !== "single"
              ? getColumnProperty.call(
                  this,
                  "imported",
                  false,
                  this.props.type === "single"
                )
              : true,
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
          ...getInitialWidthOrFlexSmall.call(
            this,
            "imported",
            this.props.type === "single"
          ),
          headerComponentFramework: () =>
            this.createSortData("Imported", "imported", "imported"),
        },
        {
          field: this.props.type === "single" ? "added" : "created",
          headerName: this.props.type === "single" ? "ADDED" : "CREATED",
          hide: getColumnProperty.call(
            this,
            this.props.type === "single" ? "added" : "created",
            this.props.type !== "single",
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
          ...getInitialWidthOrFlexSmall.call(
            this,
            "added",
            this.props.type === "single"
          ),
          headerComponentFramework: () =>
            this.createSortData(
              this.props.type === "single" ? "Added" : "Created",
              "created",
              "created"
            ),
        },
        {
          cellRendererFramework: (params) => (
            <CustomTooltipWrapper {...params} field="custom1" />
          ),
          field: "custom1",
          headerComponentFramework: () =>
            this.createSortData("Custom 1", "custom_field_1", "custom_field_1"),
          headerName: "CUSTOM 1",
          hide: getColumnProperty.call(
            this,
            "custom1",
            true,
            this.props.type === "single"
          ),
          initialWidth: getInitialWidth.call(
            this,
            "custom1",
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
        },
        {
          cellRendererFramework: (params) => (
            <CustomTooltipWrapper {...params} field="custom2" />
          ),
          field: "custom2",
          headerComponentFramework: () =>
            this.createSortData("Custom 2", "custom_field_2", "custom_field_2"),
          headerName: "CUSTOM 2",
          hide: getColumnProperty.call(
            this,
            "custom2",
            true,
            this.props.type === "single"
          ),
          initialWidth: getInitialWidth.call(
            this,
            "custom2",
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
        },
        {
          cellRendererFramework: (params) => (
            <CustomTooltipWrapper {...params} field="custom3" />
          ),
          field: "custom3",
          headerComponentFramework: () =>
            this.createSortData("Custom 3", "custom_field_3", "custom_field_3"),
          headerName: "CUSTOM 3",
          hide: getColumnProperty.call(
            this,
            "custom3",
            true,
            this.props.type === "single"
          ),
          initialWidth: getInitialWidth.call(
            this,
            "custom3",
            this.props.type === "single"
          ),
          resizable: CONSTS.IS_RESIZABLE_TABLE ? true : false,
          suppressMovable: true,
        },
        {
          cellRenderer: "ActionBtnRenderer",
          headerName: "Action Buttons",
          pinned: "right",
          width:
            this.props.type === "single" &&
            this.props.campaignStatus !== "Compose"
              ? 170
              : 50,
        },
      ],
      confirmationDialog: {
        data: {},
        id: null,
        status: false,
      },
      confirmationDialogContacts: {
        data: {},
        status: false,
      },
      contacts: this.props.contacts,
      contactsModal: this.props.contactsModal,
      dropDownController: false,
      dropDownControllerContact: "",
      filterRows: [],
      getRowNodeId(data) {
        return data.id;
      },
      gridApi: null,
      hide: false,

      initialValuePagination: contactsPageSize.get(),
      isCampaignsRunning:
        this.props.campaignStatus === "Running" ||
        this.props.campaignStatus === "Stopped" ||
        this.props.campaignStatus === "Completed",
      isDelete: false,
      isDeleteContactsOpened: false,
      isExcludeContactsOpened: false,
      isLoadingCSV: false,
      isLoadingCSVCampaigns: false,
      isLoadingInteractionLog: false,
      isOpenMenuPagination: false,
      isRunningCampaigns:
        this.props.type === "single" && this.props.campaignStatus !== "Compose",
      needLoader: false,
      rowData: transformContactsData.call(this, avatarSvg),
      scrollBarWidth: false,
      selectAllUsersValue: false,
      selected: [],

      selectedValues: 0,
      status: this.props.campaignStatus,
      type: this.props.type,
    };

    this.onGridReadyBound = onGridReady.bind(this);
    this.SavedColState = React.createRef();
  }

  buttonsActions = (row, type, index) => {
    if (type === "single" || type === "all") {
      if (row.campaignExecutions?.actions) {
        return (
          row.campaignExecutions?.actions && (
            <BtnGroupContainer
              campaignId={this.props.campaignId}
              campaignStatus={this.props.campaignStatus}
              dropDownController={dropDownController.bind(this)}
              dropDownControllerValue={this.state.dropDownController}
              handlerCompleteExecutions={handlerCompleteExecutions.bind(this)}
              index={index}
              removeContactsFromCampaign={removeContactsFromCampaign.bind(this)}
              row={row}
              size={this.props.contacts.length}
              type={type}
            />
          )
        );
      }
      if (row.actions?.open_linkedin_profile.enabled) {
        return (
          <div
            className={
              type === "all"
                ? "btn-group-table-info-accent"
                : "btn-group-table-info"
            }
          >
            {type === "all" && (
              <InformationBlock
                dropDownController={dropDownControllerContact.bind(this)}
                dropDownControllerValue={this.state.dropDownControllerContact}
                history={this.props.history}
                index={index}
                row={row}
                size={this.props.contacts.length}
              />
            )}
            <TooltipCustom
              arrow
              title={row.actions?.open_linkedin_profile.hint}
            >
              <button
                className={
                  row.actions?.open_linkedin_profile.enabled
                    ? "btn-row info"
                    : "btn-row info disabled"
                }
                onClick={() => linkedInProfileOpener.open(row)}
              >
                <img alt="linkedin icon" src={inIconGray} />
              </button>
            </TooltipCustom>
          </div>
        );
      }
    }
  };

  changePagination(value) {
    this.setState({
      initialValuePagination: value,
    });

    this.props.setInitialValuePagination(value.toString());

    contactsPageSize.save(value);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.contacts && this.props.contacts !== prevProps.contacts) {
      this.setState({
        contacts: this.props.contacts,
        rowData: transformContactsData.call(this, avatarSvg),
      });
    }
    if (
      (this.props.contactsModal &&
        this.props.contactsModal !== prevProps.contactsModal) ||
      (this.props.isModalVisible &&
        this.props.isModalVisible !== prevProps.isModalVisible)
    ) {
      this.setState({
        contactsModal: this.props.contactsModal,
        rowData: transformContactsData.call(this, avatarSvg),
      });
    }

    if (
      this.props.isTableSettingsVisible &&
      this.props.isTableSettingsVisible !== prevProps.isTableSettingsVisible
    ) {
      saveState.call(this);
    }
    if (this.props.match.url !== prevProps.match.url) {
      this.props.dispatch({
        type: "FILTERS_QUERY_CLEAR",
      });
    }
    if (
      this.props.isFiltering !== prevProps.isFiltering &&
      this.type !== "add-to-campaign"
    ) {
      getContactsBySort.call(this);
    }
    if (
      this.props.isFilteringExecutions !== prevProps.isFilteringExecutions &&
      this.type !== "add-to-campaign"
    ) {
      getContactsBySort.call(this);
    }
    if (
      this.state.initialValuePagination !== prevState.initialValuePagination
    ) {
      handleChangePage.call(this);
    }
  }

  createData = (text) => {
    return (
      <div className="container-title-images">
        <p className="main-title">{text}</p>
      </div>
    );
  };

  createSortData = (text, sort, index) => {
    return (
      <div className="container-title-images">
        <SortIcon
          idx={index}
          isFiltering={
            this.state.isRunningCampaigns
              ? this.props.isFilteringExecutions
              : this.props.isFiltering
          }
          isRunning={this.state.isRunningCampaigns}
          isSortedAsc={
            this.state.isRunningCampaigns
              ? this.props.isIconActiveExecutions
              : this.props.isIconActive
          }
          setIsFiltering={
            this.state.isRunningCampaigns
              ? this.props.setIsFilteringExecutions
              : this.props.setIsFiltering
          }
          setIsSortedAsc={
            this.state.isRunningCampaigns
              ? this.props.setActiveFilterIconExecutions
              : this.props.setActiveFilterIcon
          }
          sort={sort}
          status={this.props.type === "single"}
          text={text}
        />
      </div>
    );
  };

  render() {
    const newPage =
      this.props.type === "add-to-campaign"
        ? this.props.contactsPageModal
        : this.props.contactsPage;
    const contactsCount =
      this.props.type === "add-to-campaign"
        ? this.props.contactsCountModal
        : this.props.contactsCount;
    const stylePagination = getStylePagination(this.state.isOpenMenuPagination);

    const accentPagination =
      contactsCount && contactsCount > this.state.initialValuePagination;

    return (
      <>
        {this.props.isTableSettingsVisible && (
          <div
            className="backdrop"
            onClick={() => this.props.setIsTableSettingsVisible(false)}
          />
        )}
        <div
          className="ag-theme-balham"
          style={{
            height: heightGenerator.call(
              this,
              this.props.campaignStatus !== "Compose"
                ? this.props.type
                : "compose"
            ),
            position: "relative",
            width: "calc(100% - 60px)",
          }}
        >
          {this.state.selectedValues > 0 && (
            <div className="selected-rows">
              <>
                <div className="container-checked">
                  <Checkbox
                    checked={this.state.selected.length > 0}
                    checkedIcon={
                      <img
                        alt="checkbox"
                        src={
                          this.props.type === "add-to-campaign"
                            ? this.props.contactsModal.length >
                              this.state.selectedValues
                              ? partiallySelectedCheckboxIcon
                              : selectedCheckboxIcon
                            : this.props.contacts.length >
                                this.state.selectedValues
                              ? partiallySelectedCheckboxIcon
                              : selectedCheckboxIcon
                        }
                      />
                    }
                    icon={<img alt="checkbox" src={notSelectedCheckboxIcon} />}
                    indeterminate={
                      this.props.type === "add-to-campaign"
                        ? this.props.contactsModal &&
                          this.props.contactsModal.length <
                            this.state.selected.filter((item) =>
                              this.props.contactsModal.includes(item)
                            ).length
                        : this.props.contacts &&
                          this.props.contacts.length <
                            this.state.selected.filter((item) =>
                              this.props.contacts.includes(item)
                            ).length
                    }
                    inputProps={{ "aria-label": "select all items" }}
                    onChange={() => onSelectAllPageClick.call(this, false)}
                  />
                </div>
                {this.state.selectedValues > 0 && (
                  <div>
                    <span className="select-text">
                      {this.state.selectedValues} of {contactsCount} selected |{" "}
                    </span>
                    {!this.state.selectAllUsersValue && (
                      <span
                        className="clear-all"
                        onClick={onSelectAllClick.bind(this)}
                      >
                        Select all
                      </span>
                    )}

                    {this.state.selectAllUsersValue && (
                      <span
                        className="clear-all"
                        onClick={onClearAllClick.bind(this)}
                      >
                        Clear
                      </span>
                    )}
                  </div>
                )}
                {this.props.checkboxs && (
                  <div className="btn-group-accent">
                    {this.props.type === "all" && (
                      <>
                        <div className="background-button">
                          <ExportToCSVButton
                            disabled={areDisabledSelectionActions.call(this)}
                            isLoading={this.state.isLoadingCSV}
                            onClick={() => {
                              exportContacts.call(this);
                            }}
                            text="Export to CSV"
                          />
                        </div>

                        <div className="background-button">
                          <ButtonCreateCampaigns
                            activeImportId={this.props.activeImportId}
                            classes={
                              areDisabledSelectionActions.call(this)
                                ? "btn with-transparent-background-disabled "
                                : " btn with-transparent-background-active "
                            }
                            clearCheckboxesFunc={clearCheckboxes.bind(this)}
                            contacts={this.state.selected}
                            disabled={areDisabledSelectionActions.call(this)}
                            from={this.props.from}
                            keywords={this.props.keywords}
                            selectAllUsersValue={this.state.selectAllUsersValue}
                            text="Add to campaign"
                            type="add"
                          />
                        </div>
                        <div className="background-button">
                          <ButtonCreateCampaigns
                            activeImportId={this.props.activeImportId}
                            classes={
                              areDisabledSelectionActions.call(this)
                                ? "btn with-transparent-background-disabled "
                                : " btn with-transparent-background-active "
                            }
                            clearCheckboxesFunc={clearCheckboxes.bind(this)}
                            contacts={this.state.selected}
                            disabled={areDisabledSelectionActions.call(this)}
                            from={this.props.from}
                            keywords={this.props.keywords}
                            selectAllUsersValue={this.state.selectAllUsersValue}
                            text="Create campaign"
                            type="new"
                          />
                        </div>
                        <div className="background-button">
                          <ResponsiveButton
                            className={
                              areDisabledSelectionActions.call(this)
                                ? "btn-pagination-remove-disabled"
                                : "btn-pagination-remove"
                            }
                            disabled={areDisabledSelectionActions.call(this)}
                            onClick={() => {
                              previewContacts.call(this);
                            }}
                          >
                            <>
                              <img
                                alt="timeIcon"
                                src={
                                  areDisabledSelectionActions.call(this)
                                    ? iconRemoveDisabled
                                    : iconRemove
                                }
                              />
                              <span>Delete</span>
                            </>
                          </ResponsiveButton>
                        </div>
                      </>
                    )}
                    {this.props.type === "single" && (
                      <>
                        {this.props.campaignStatus !== "Compose" && (
                          <div className="background-button">
                            {this.props.profile?.isProPlanAccessible ===
                            false ? (
                              <>
                                <TooltipCustom
                                  arrow
                                  title="Upgrade your plan to Pro"
                                >
                                  <div className="wrapper-background-button-pro">
                                    <div className="background-button-pro">
                                      pro
                                    </div>
                                  </div>
                                </TooltipCustom>
                                <ExportToCSVButton
                                  disabled
                                  isInteraction
                                  isLoading={this.state.isLoadingInteractionLog}
                                  onClick={() => {
                                    exportRecentActivities.call(this);
                                  }}
                                  text="Export Interaction Log"
                                />
                              </>
                            ) : (
                              <ExportToCSVButton
                                disabled={false}
                                isInteraction
                                isLoading={this.state.isLoadingInteractionLog}
                                onClick={() => {
                                  exportRecentActivities.call(this);
                                }}
                                text="Export Interaction Log"
                              />
                            )}
                          </div>
                        )}
                        <div className="background-button">
                          <ExportToCSVButton
                            disabled={areDisabledSelectionActions.call(this)}
                            isLoading={this.state.isLoadingCSVCampaigns}
                            onClick={() => {
                              exportContactsForCampaign.call(this);
                            }}
                            text="Export Contacts"
                          ></ExportToCSVButton>
                        </div>
                      </>
                    )}
                    {this.props.type === "single" && (
                      <div className="background-button">
                        <button
                          className={
                            areDisabledSelectionActions.call(this)
                              ? "btn-row-exclude-disabled"
                              : "btn-row-exclude"
                          }
                          disabled={areDisabledSelectionActions.call(this)}
                          onClick={() =>
                            (this.state.isCampaignsRunning &&
                              onClickExclude.call(this)) ||
                            this.setState({
                              isExcludeContactsOpened: true,
                            })
                          }
                        >
                          {this.state.needLoader ? (
                            <div className="container-loader-executions">
                              <CircularProgress
                                classes={{
                                  colorPrimary: "material-loader-accent",
                                }}
                                size={20}
                              />
                            </div>
                          ) : (
                            <>
                              <img
                                alt="timeIcon"
                                src={
                                  areDisabledSelectionActions.call(this)
                                    ? iconExcludeDisabled
                                    : iconExclude
                                }
                              />
                              <span>Exclude</span>
                            </>
                          )}
                        </button>
                      </div>
                    )}
                    {this.props.type === "add-to-campaign" && (
                      <>
                        <div className="btn-group-accent">
                          <div className="background-button">
                            <ButtonAddToCampaigns
                              activeImportId={this.props.campaignId}
                              campaign={this.props.campaign}
                              classes={"button-modal"}
                              contacts={this.state.selected}
                              contactsCount={this.props.contactsCountModal}
                              contactsPage={this.props.contactsModal}
                              disabled={areDisabledSelectionActions.call(this)}
                              from={this.props.from}
                              getContacts={this.props.getContacts}
                              history={this.props.history}
                              keywords={this.props.keywords}
                              page={newPage}
                              searchValue={this.props.searchValue}
                              selectAllUsersValue={
                                this.state.selectAllUsersValue
                              }
                              setPage={this.props.setPage}
                              setSelectedContacts={() =>
                                this.setState({
                                  selected: [],
                                  selectedValues: 0,
                                })
                              }
                              text="Add to campaign"
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </>
            </div>
          )}
          {this.props.app.tableContentLoader &&
          !this.props.app.pageContentLoader ? (
            <div className="table-material-loader-wrapper">
              <CircularProgress
                classes={{ colorPrimary: "material-loader" }}
                color="primary"
                size={60}
              />
            </div>
          ) : (
            <AgGridReact
              animateRows
              columnDefs={this.state.columnDefs}
              frameworkComponents={{
                ActionBtnRenderer: (props) =>
                  (this.props.type === "single" || this.props.type === "all") &&
                  this.buttonsActions(
                    props.data,
                    this.props.type,
                    props.node.rowIndex
                  ),
                cellRendererFramework: (params) => (
                  <CustomTooltipWrapper {...params} />
                ),
                CustomCellRenderer,
                CustomCellStatusRerender: (props) =>
                  this.props.type === "single" &&
                  this.props.campaignStatus !== "Compose"
                    ? this.renderSteps(
                        props.data.campaignExecutions?.step_executions,
                        props.data.campaignExecutions
                      )
                    : "...",
                CustomCheckbox,
                HeaderCheckbox,
              }}
              getRowNodeId={(data) => data.id}
              onColumnResized={onColumnResized.bind(this)}
              onGridReady={onGridReady.bind(this)}
              rowData={this.state.rowData}
              rowSelection="multiple"
              suppressRowClickSelection
            />
          )}
          <div
            className={
              accentPagination ? "table-footer-accent" : "table-footer"
            }
          >
            {accentPagination ? (
              <PaginationWrapper
                component="div"
                count={contactsCount}
                onPageChange={handleChangePage.bind(this)}
                page={getNewPage.call(this)}
                rowsPerPage={this.state.initialValuePagination}
                rowsPerPageOptions={[]}
              />
            ) : (
              <div />
            )}

            <div
              className={
                accentPagination ? "wrapper-select" : "wrapper-select-accent"
              }
            >
              <Select
                onBlur={() => {
                  this.setState({
                    isOpenMenuPagination: false,
                  });
                }}
                onChange={(e) => {
                  const value = Number(e.value);
                  this.changePagination(value);
                }}
                onFocus={() => {
                  this.setState({
                    isOpenMenuPagination: true,
                  });
                }}
                options={SHOW_ITEMS}
                styles={stylePagination}
                value={SHOW_ITEMS.find(
                  (el) => el.value === this.state.initialValuePagination
                )}
              />
            </div>
          </div>

          <ModalWindow
            closeHandler={() =>
              this.setState({ isExcludeContactsOpened: false })
            }
            closeText="No"
            confirmHandler={deleteHandler.bind(this)}
            confirmText="Yes"
            content={
              CONSTS.confirmationDialogs[
                this.state.isCampaignsRunning ? 1.8 : 1.6
              ].content
            }
            open={this.state.isExcludeContactsOpened}
            setIsDelete={(value) => {
              this.setState({ isDelete: value });
            }}
            title={
              CONSTS.confirmationDialogs[
                this.state.isCampaignsRunning ? 1.8 : 1.6
              ].title
            }
          />
          {this.state.isCampaignsRunning && (
            <ModalWindow
              classes={"confirmation-launch-modal"}
              closeHandler={() =>
                this.setState({
                  confirmationDialog: {
                    data: {},
                    id: null,
                    status: false,
                  },
                })
              }
              open={this.state.confirmationDialog.status}
            >
              <ConfirmationDialogExclude
                closeHandler={() =>
                  this.setState({
                    confirmationDialog: {
                      data: {},
                      id: null,
                      status: false,
                    },
                  })
                }
                confirmationDialog={this.state.confirmationDialog}
                exclude={removeExecutionsFromCampaign.bind(this)}
              />
            </ModalWindow>
          )}
          <ModalWindow
            classes={"confirmation-launch-modal"}
            closeHandler={() =>
              this.setState({
                confirmationDialogContacts: {
                  data: {},
                  id: null,
                  status: false,
                },
              })
            }
            open={this.state.confirmationDialogContacts.status}
          >
            <ConfirmationDialogContacts
              closeHandler={() =>
                this.setState({
                  confirmationDialogContacts: {
                    data: {},
                    id: null,
                    status: false,
                  },
                })
              }
              confirmationDialogContacts={this.state.confirmationDialogContacts}
              deleted={deleteContacts.bind(this)}
            />
          </ModalWindow>

          <ModalWindow
            closeHandler={() =>
              this.setState({ isDeleteContactsOpened: false })
            }
            closeText="No"
            confirmHandler={deleteContacts.bind(this)}
            confirmText="Yes"
            content={CONSTS.confirmationDialogs[1.9].content.replace(
              "{contacts_count}",
              this.state.selectedValues
            )}
            open={this.state.isDeleteContactsOpened}
            title={CONSTS.confirmationDialogs[1.9].title.replace(
              "{contacts_count}",
              this.state.selectedValues
            )}
          />
        </div>
        {this.props.isTableSettingsVisible && (
          <TableSettingsModal
            closeModal={() => this.props.setIsTableSettingsVisible(false)}
            executions={this.props.type === "single"}
            updateDataSizeTable={this.updateDataSizeTable}
          />
        )}
      </>
    );
  }

  renderSteps = (row, item) => {
    const items = [];
    for (const index in row) {
      row[index].is_visible &&
        items.push(
          <TooltipCustom arrow isVisible key={index} title={row[index].hint}>
            <div
              className="steps-container-item"
              style={{
                background: `${statesDescriptor.detectColor(
                  item.human_state,
                  row[index]
                )}`,
              }}
            />
          </TooltipCustom>
        );
    }

    return <div className="steps-container">{items}</div>;
  };

  updateDataSizeTable = (dataSizeTable) => {
    if (this.state.type !== "single") {
      localStorage.setItem(
        "contactsGridSettings",
        JSON.stringify(dataSizeTable)
      );
      this.state.gridColumnApi.applyColumnState({ state: dataSizeTable });
    } else if (this.state.type === "single") {
      localStorage.setItem(
        "executionsGridSettings",
        JSON.stringify(dataSizeTable)
      );
      this.state.gridColumnApi.applyColumnState({ state: dataSizeTable });
    }
  };
}

const mapStateToProps = (state) => ({
  app: state.app,
  campaign: state.campaign,
  campaigns: state.campaigns,
  contacts: state.contacts.contacts,
  contactsCountModal: state.contacts.contactsCountModal,
  contactsModal: state.contacts.contactsModal,
  contactsPage: state.contacts.contactsPage,
  contactsPageModal: state.contacts.contactsPageModal,
  isModalVisible: state.contacts.isModalVisible,
  profile: appSelectors.appProfile(state),
});

export default connect(mapStateToProps)(TableUsers);
